module.exports = __webpack_public_path__ + "img/update.186da816.png";